/**
 * Map of error messages that can be thrown.
 *
 * @internal
 */
interface ErrorMessages {
  invalidStore: string;
}

/**
 * Map of error messages that can be thrown.
 *
 * @internal
 */
export const errors: ErrorMessages = {
  invalidStore: 'Provided value is not a valid store instance.',
};
